/**
 * Optional client-side session log (download to the user's device).
 */

const MAX_CHARS = 2_000_000; // ~2MB soft cap

let buffer = "";
let enabled = false;

export function setLoggingEnabled(on: boolean): void {
  enabled = on;
}

export function isLoggingEnabled(): boolean {
  return enabled;
}

export function appendLog(plain: string): void {
  if (!enabled || !plain) return;
  buffer += plain;
  if (buffer.length > MAX_CHARS) {
    buffer = buffer.slice(buffer.length - MAX_CHARS);
  }
}

export function clearLog(): void {
  buffer = "";
}

export function getLogSize(): number {
  return buffer.length;
}

export function downloadLog(filename?: string): void {
  const name =
    filename ??
    `mdhoria-log-${new Date().toISOString().replace(/[:.]/g, "-")}.txt`;
  const blob = new Blob([buffer || "(empty log)\n"], {
    type: "text/plain;charset=utf-8",
  });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  URL.revokeObjectURL(a.href);
}
